( function () {
	function initCountdown() {
		const elements = document.querySelectorAll( '.countdown-display' );

		if ( ! elements.length ) {
			return;
		}
		elements.forEach( el => {
			const rawTime = el.dataset.time;

			if ( ! rawTime ) {
				return;
			}

			const target = parseInt( rawTime ) * 1000;

			if ( isNaN( target ) ) {
				return;
			}
			function getDigitsHTML( value ) {
				return String( value )
					.padStart( 2, '0' )
					.split( '' )
					.map( digit => `<span class="digit">${ digit }</span>` )
					.join( '' );
			}

			function updateTimer() {
				const now = new Date().getTime();
				const diff = target - now;

				if ( diff <= 0 ) {
					el.innerHTML = `
                        <div class="timer-block">
                            <div class="timer-block-number">
                                <span class="digit">0</span>
                                <span class="digit">0</span>
                            </div>
                            <span class="label">DAYS</span>
                        </div>
                        <div class="timer-separator">:</div>
                        <div class="timer-block">
                            <div class="timer-block-number">
                                <span class="digit">0</span>
                                <span class="digit">0</span>
                            </div>
                            <span class="label">HRS</span>
                        </div>
                        <div class="timer-separator">:</div>
                        <div class="timer-block">
                            <div class="timer-block-number">
                                <span class="digit">0</span>
                                <span class="digit">0</span>
                            </div>
                            <span class="label">MIN</span>
                        </div>
						<div class="timer-separator">:</div>

						<div class="timer-block">
							<div class="timer-block-number">
								<span class="digit">0</span>
								<span class="digit">0</span>
							</div>
							<span class="label">SEC</span>
						</div>
                    `;
					return;
				}

				const days = Math.floor( diff / ( 1000 * 60 * 60 * 24 ) );
				const hours = Math.floor( ( diff / ( 1000 * 60 * 60 ) ) % 24 );
				const mins = Math.floor( ( diff / ( 1000 * 60 ) ) % 60 );
				const secs = Math.floor( ( diff / 1000 ) % 60 );

				el.innerHTML = `
                    <div class="timer-block">
                        <div class="timer-block-number">
                            ${ getDigitsHTML( days ) }
                        </div>
                        <span class="label">DAYS</span>
                    </div>
                    <div class="timer-separator">:</div>
                    <div class="timer-block">
                        <div class="timer-block-number">
                            ${ getDigitsHTML( hours ) }
                        </div>
                        <span class="label">HRS</span>
                    </div>
                    <div class="timer-separator">:</div>
                    <div class="timer-block">
                        <div class="timer-block-number">
                            ${ getDigitsHTML( mins ) }
                        </div>
                        <span class="label">MIN</span>
                    </div>
					<div class="timer-separator">:</div>

					<div class="timer-block">
						<div class="timer-block-number">
							${ getDigitsHTML( secs ) }
						</div>
						<span class="label">SEC</span>
					</div>
                `;
			}

			updateTimer();
			
			setInterval( updateTimer, 1000 );
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initCountdown );
	} else {
		initCountdown();
	}
} )();
